export const RECEIVE_REFERRAL_WIZARD_DATA = 'RECEIVE_REFERRAL_WIZARD_DATA';

export function receiveReferralWizardData(
  availableNetworks,
  inboundReferrableSpecialties
) {
  return {
    type: RECEIVE_REFERRAL_WIZARD_DATA,
    availableNetworks: availableNetworks,
    inboundReferrableSpecialties: inboundReferrableSpecialties,
  };
}
